/* eslint-disable react/no-deprecated */

import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaPersonalDetails.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputText, Button, InputSelect, InputCheckBox, FormGroup, Space, Interactive } from "AtomicComponents"
import InputSearchable from "../InputSearchable/InputSearchable"
import { AlertList } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formSetDefaultValues, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import { CancelIcon } from "components"

const TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof"
  .split("|")
  .map(label => ({ label, value: label }))

const STATES = "ACT|NSW|NT|QLD|SA|TAS|VIC|WA"
  .split("|")
  .map(label => ({ label, value: label.toLowerCase() }))

class MyMazdaPersonalDetails extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        surname: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        mobilePhone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            mobilePhone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        afterHoursPhone: {
          validations: {
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        businessHoursPhone: {
          validations: {
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        businessHoursPhoneExtension: {
          validations: {
            extension: MESSAGES.PHONE_EXTENSION_INVALID
          }
        },
        address: {
          validations: {
            address: MESSAGES.ADDRESS_INVALID
          }
        },
        manualAddress: {
          validations: {
          }
        },
        address1: {
          validations: {
            required: MESSAGES.ADDRESS_REQUIRED
          }
        },
        address2: {
          validations: {
          }
        },
        address3: {
          validations: {
          }
        },
        townName: {
          validations: {
            required: MESSAGES.ADDRESS2_REQUIRED
          }
        },
        postcode: {
          validations: {
            required: MESSAGES.ADDRESS3_REQUIRED
          }
        },
        state: {
          validations: {
            required: MESSAGES.STATE_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  componentDidMount() {
    const { customer } = this.props

    if (customer) {
      formSetDefaultValues(this, {
        title: customer.title,
        firstName: customer.firstName,
        surname: customer.surname,
        mobilePhone: customer.mobilePhone,
        afterHoursPhone: customer.afterHoursPhone,
        businessHoursPhone: customer.businessHoursPhone,
        businessHoursPhoneExtension: customer.businessHoursPhoneExtension,
        address1: customer.address.address1,
        address2: customer.address.address2,
        address3: customer.address.address3,
        townName: customer.address.townName,
        postcode: customer.address.postcode,
        state: customer.address.state.toLowerCase()
      })
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { updatePersonalDetailsEndpoint, customer } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "PUT",
          url: updatePersonalDetailsEndpoint,
          body: {
            ...customer,
            title: form.title.value,
            firstName: form.firstName.value,
            surname: form.surname.value,
            mobilePhone: form.mobilePhone.value,
            afterHoursPhone: form.afterHoursPhone.value,
            businessHoursPhone: form.businessHoursPhone.value,
            businessHoursPhoneExtension: form.businessHoursPhoneExtension.value,
            address: {
              ...customer.address,
              address1: form.address1.value,
              address2: form.address2.value,
              address3: form.address3.value,
              townName: form.townName.value,
              postcode: form.postcode.value,
              state: form.state.value
            }
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda Details Form",
                  pageAction: "MyMazda Details Form - Submit"
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  handleAddressChange = (address) => {
    if (address) {
      if (address.structured_formatting && address.structured_formatting.main_text) {
        formSetDefaultValues(this, { address1: address.structured_formatting.main_text })
      }
      if (address.suburb) {
        formSetDefaultValues(this, { townName: address.suburb })
      }
      if (address.postcode) {
        formSetDefaultValues(this, { postcode: address.postcode })
      }
      if (address.state) {
        formSetDefaultValues(this, { state: address.state.toLowerCase() })
      }

      gtmHandler({
        pageCategory: "Personal details Form",
        pageAction: "Personal details Form - Selected address"
      })
    }
  }

  render() {
    const { onUpdate } = this.props
    const { loading, success, errorMessage, form } = this.state
    const editAdressManually = form.manualAddress ? form.manualAddress.value : false

    if (success) {
      onUpdate({ success: true })
      return null
    }

    return (
      <div className={classnames({ [styles.MyMazdaPersonalDetails]: true })}>
        <div className={classnames({ [styles.MyMazdaPersonalDetailsForm]: true })}>
          <form onSubmit={this._handleSubmit}>
            <FormGroup>
              <div className={classnames({ [styles.MyMazdaPersonalDetailsFormWrapper]: true })}>
                <Interactive>Update Personal Details</Interactive>
                <span onClick={onUpdate} className={classnames({ [styles.MyMazdaPersonalDetailsFormCancel]: true })}>
                  <CancelIcon style={{ fill: "currentColor", width: "1em", height: "1em", marginRight: "0.5em" }} />
                  Cancel
                </span>
              </div>
              <Space />
            </FormGroup>
            <FormGroup>
              <InputSelect
                name="title"
                label="Title"
                options={TITLES}
                {...fromLinkInputs(this, "title")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Selected \"TITLE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="firstName"
                label="First Name"
                {...fromLinkInputs(this, "firstName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"FIRSTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="surname"
                label="Last Name"
                {...fromLinkInputs(this, "surname")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"LASTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="mobilePhone"
                label="Mobile Phone"
                {...fromLinkInputs(this, "mobilePhone")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"MOBILE PHONE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="afterHoursPhone"
                label="After hours phone"
                {...fromLinkInputs(this, "afterHoursPhone")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"AFTER HOURS PHONE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <div style={{ display: "flex" }}>
                <div style={{ flex: "0 1 100%", marginRight: "1em" }}>
                  <InputText
                    name="businessHoursPhone"
                    label="Business hours phone"
                    {...fromLinkInputs(this, "businessHoursPhone")}
                    onBlur={() => {
                      gtmHandler({
                        pageCategory: "Personal details Form",
                        pageAction: "Personal details Form - Entered \"BUSINESS HOURS PHONE\""
                      })
                    }}
                  />
                </div>
                <div style={{ flex: "0 1 50%" }}>
                  <InputText
                    name="businessHoursPhoneExtension"
                    label="Extension"
                    {...fromLinkInputs(this, "businessHoursPhoneExtension")}
                    onBlur={() => {
                      gtmHandler({
                        pageCategory: "Personal details Form",
                        pageAction: "Personal details Form - Entered \"EXTENSION\""
                      })
                    }}
                  />
                </div>
              </div>
            </FormGroup>
            <FormGroup>
              <Space />
              <Space />
              <Interactive>Edit address</Interactive>
              <InputSearchable
                name="address"
                type="address"
                label="Address"
                {...fromLinkInputs(this, "address")}
                onBlur={this.handleAddressChange}
              />
            </FormGroup>
            <FormGroup>
              <InputCheckBox
                name="privacy"
                label={"Enter address manually"}
                {...fromLinkInputs(this, "manualAddress", () => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Checked \"Manual Addess\""
                  })
                })}
              />
            </FormGroup>
            <FormGroup hide={!editAdressManually}>
              <InputText
                name="address1"
                label="Address (Line 1)"
                {...fromLinkInputs(this, "address1")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"Address1\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup hide={!editAdressManually}>
              <InputText
                name="address2"
                label="Address (Line 2)"
                {...fromLinkInputs(this, "address2")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"Address2\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup hide={!editAdressManually}>
              <InputText
                name="address3"
                label="Address (Line 3)"
                {...fromLinkInputs(this, "address3")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"Address3\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup hide={!editAdressManually}>
              <InputText
                name="townName"
                label="Suburb"
                {...fromLinkInputs(this, "townName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Personal details Form",
                    pageAction: "Personal details Form - Entered \"Suburb\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup hide={!editAdressManually}>
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <div style={{ flex: "0 1 50%", marginRight: "1em" }}>
                  <InputText
                    name="postcode"
                    label="Postcode"
                    {...fromLinkInputs(this, "postcode")}
                    onBlur={() => {
                      gtmHandler({
                        pageCategory: "Personal details Form",
                        pageAction: "Personal details Form - Entered \"postcode\""
                      })
                    }}
                  />
                </div>
                <div style={{ flex: "0 1 50%" }}>
                  <InputSelect
                    name="state"
                    label="State"
                    options={STATES}
                    {...fromLinkInputs(this, "state")}
                    onBlur={()=>{
                      gtmHandler({
                        pageCategory: "Personal details Form",
                        pageAction: "Personal details Form - Selected \"STATE\""
                      })
                    }}
                  />
                </div>
              </div>
            </FormGroup>
            <FormGroup>
              <AlertList data={errorMessage} />
              <Button styleName="black" loading={loading} fullWidth {...formLinkSubmit(this, this._handleSubmit)}>
                Save
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default MyMazdaPersonalDetails



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaPersonalDetails/MyMazdaPersonalDetails.jsx